'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('App');

(0, _jquery2.default)(document).on('change', '[data-user-sendnewsletter]', function () {
    var $this = (0, _jquery2.default)(this);
    var userId = parseInt($this.attr('data-userid'), 10);
    var hasNewsletter = $this.is(':checked');
    abp.services.api.user.updateNewsletter(userId, hasNewsletter).done(function (result) {
        if (hasNewsletter) {
            _notify2.default.success(Resx.App.NewsletterSubscribed);
        } else {
            _notify2.default.success(Resx.App.NewsletterUnsubscribed);
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/user.js
// module id = 1095
// module chunks = 1